export default __webpack_public_path__ + "static/media/moving-boxes.43b01c62.jpeg";